import { Box, Grid, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import "../../assets/styles/Styles.css";
import {
  materialCollectors,
  qualityProcesses,
} from "../../layouts/sections/Tools";

const HomePage = () => {
  return (
    <Box sx={{ p: 10 }}>
      <Box mb={6}>
        <Typography variant="h5" gutterBottom>
          Material collectors
        </Typography>
        <Grid container spacing={4}>
          {materialCollectors.map((tool) => (
            <Grid sx={{ xs: 12, sm: 6, md: 3 }} key={tool.name}>
              <Link
                component={RouterLink}
                to={tool.route}
                underline="none"
                className="tool-button"
              >
                {tool.name}
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box>
        <Typography variant="h5" gutterBottom>
          Quality control processes
        </Typography>
        <Grid container spacing={4}>
          {qualityProcesses.map((tool) => (
            <Grid sx={{ xs: 12, sm: 6, md: 3 }} key={tool.name}>
              <Link
                component={RouterLink}
                to={tool.route}
                underline="none"
                className="tool-button"
              >
                {tool.name}
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default HomePage;
